export enum getObjectivesAT {
  Request = 'GET_OBJECTIVES_REQUEST',
  Success = 'GET_OBJECTIVES_SUCCESS',
  Failed = 'GET_OBJECTIVES_FAILED',
}

export enum getObjectiveActions {
  Request = 'GET_OBJECTIVE_REQUEST',
  Success = 'GET_OBJECTIVE_SUCCESS',
  Failed = 'GET_OBJECTIVE_FAILED',
}

export enum updateObjectiveActions {
  Request = 'UPDATE_OBJECTIVE_REQUEST',
  Success = 'UPDATE_OBJECTIVE_SUCCESS',
  Failed = 'UPDATE_OBJECTIVE_FAILED',
}

export enum postObjectiveActions {
  Request = 'POST_OBJECTIVE_REQUEST',
  Success = 'POST_OBJECTIVE_SUCCESS',
  Failed = 'POST_OBJECTIVE_FAILED',
}

export enum deleteObjectiveActions {
  Request = 'DELETE_OBJECTIVE_REQUEST',
  Success = 'DELETE_OBJECTIVE_SUCCESS',
  Failed = 'DELETE_OBJECTIVE_FAILED',
}

export enum getSubobjectivesActions {
  Request = 'GET_SUBOBJECTIVES_REQUEST',
  Success = 'GET_SUBOBJECTIVES_SUCCESS',
  Failed = 'GET_SUBOBJECTIVES_FAILED',
}

export enum deleteSubobjectiveActions {
  Request = 'DELETE_SUBOBJECTIVE_REQUEST',
  Success = 'DELETE_SUBOBJECTIVE_SUCCESS',
  Failed = 'DELETE_SUBOBJECTIVE_FAILED',
}

export enum postSubobjectiveActions {
  Request = 'PUT_SUBOBJECTIVE_REQUEST',
  Success = 'PUT_SUBOBJECTIVE_SUCCESS',
  Failed = 'PUT_SUBOBJECTIVE_FAILED',
}

export const clearObjectiveActionHack = 'CLEAR_OBJECTIVE_HACK';
